var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustrationSignUpDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    height: 593,
    viewBox: "0 0 400 593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "72.75%",
    x2: "27.25%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF6A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF527B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: "22.319%",
    x2: "99.127%",
    y1: "28.497%",
    y2: "70.858%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF3E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFB443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF5B64",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#CACBE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#CACBE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: "97.791%",
    x2: "7.729%",
    y1: "26.944%",
    y2: "71.879%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF9049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF5E5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF6A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF5B66"
  })), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M0 26C0 11.64 11.64 0 26 0h381c14.36 0 26 11.64 26 26v237c0 14.36-11.64 26-26 26H26c-14.36 0-26-11.64-26-26V26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M0 11C0 4.925 4.925 0 11 0h379c6.075 0 11 4.925 11 11v237c0 6.075-4.925 11-11 11H11c-6.075 0-11-4.925-11-11V11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M0 11C0 4.925 4.925 0 11 0h379c6.075 0 11 4.925 11 11v237c0 6.075-4.925 11-11 11H11c-6.075 0-11-4.925-11-11V11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n",
    d: "M0 11C0 4.925 4.925 0 11 0h411c6.075 0 11 4.925 11 11v229c0 6.075-4.925 11-11 11H11c-6.075 0-11-4.925-11-11V11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q",
    d: "M0 4a4 4 0 0 1 4-4h90a4 4 0 0 1 4 4v122a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: "127.7%",
    height: "141.5%",
    x: "-13.9%",
    y: "-12.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 24,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.100000001 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    width: "129.9%",
    height: "146.3%",
    x: "-15%",
    y: "-13.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 24,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.100000001 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "j",
    width: "129.9%",
    height: "146.3%",
    x: "-15%",
    y: "-13.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 24,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.100000001 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "m",
    width: "127.7%",
    height: "147.8%",
    x: "-13.9%",
    y: "-14.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 24,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.100000001 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 400,
    height: 593,
    x: 0,
    y: 0,
    rx: 16
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 593,
    rx: 16
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    fillRule: "nonzero",
    d: "M0 0h400v593H0z",
    mask: "url(#c)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(-192 211)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    fill: "#000",
    filter: "url(#d)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    fill: "#242742"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-176 226)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    fill: "#000",
    filter: "url(#f)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    fill: "url(#h)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    fill: "#000",
    filter: "url(#j)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    fill: "url(#h)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 244,
    r: 158,
    fill: "url(#k)",
    fillRule: "nonzero",
    mask: "url(#l)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.446,
    cy: -34.554,
    r: 158,
    fill: "url(#k)",
    fillRule: "nonzero",
    mask: "url(#l)",
    transform: "rotate(-135 136.446 -34.554)"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(129 115)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n",
    fill: "#000",
    filter: "url(#m)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n",
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M0 11C0 4.925 4.925 0 11 0h85v251H11c-6.075 0-11-4.925-11-11V11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABBDB",
    d: "M14 50.5a3.5 3.5 0 0 1 3.5-3.5h61a3.5 3.5 0 0 1 0 7h-61a3.5 3.5 0 0 1-3.5-3.5Zm0 20a3.5 3.5 0 0 1 3.5-3.5h54a3.5 3.5 0 0 1 0 7h-54a3.5 3.5 0 0 1-3.5-3.5Zm0 20a3.5 3.5 0 0 1 3.5-3.5h61a3.5 3.5 0 0 1 0 7h-61a3.5 3.5 0 0 1-3.5-3.5Zm0 20a3.5 3.5 0 0 1 3.5-3.5h39a3.5 3.5 0 1 1 0 7h-39a3.5 3.5 0 0 1-3.5-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#242742",
    d: "M0 11C0 4.925 4.925 0 11 0h411c6.075 0 11 4.925 11 11v20H0V11Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 9)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    fill: "#FF6464"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 6.5,
    r: 6.5,
    fill: "#FF9255"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 6.5,
    r: 6.5,
    fill: "#6BD4A8"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(246 93)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M0 4a4 4 0 0 1 4-4h90a4 4 0 0 1 4 4v122a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "s",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    fillRule: "nonzero",
    d: "M108.12 28.878a3 3 0 0 1 .002 4.243L82.847 58.41c-4.348 4.351-11.4 4.351-15.749 0a5.132 5.132 0 0 0-7.26 0L42.406 75.853a8.668 8.668 0 0 1-12.262 0 2.668 2.668 0 0 0-3.774 0l-32.248 32.268a3 3 0 1 1-4.244-4.242l32.248-32.267a8.668 8.668 0 0 1 12.262 0 2.668 2.668 0 0 0 3.774 0L55.594 54.17c4.348-4.35 11.4-4.35 15.748 0a5.132 5.132 0 0 0 7.26 0l25.276-25.29a3 3 0 0 1 4.243-.002Z",
    mask: "url(#s)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M49 150a4 4 0 0 1 4-4h120a4 4 0 0 1 4 4v144a4 4 0 0 1-4 4H53a4 4 0 0 1-4-4V150Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M46.5 79C64.45 79 79 64.45 79 46.5S64.45 14 46.5 14 14 28.55 14 46.5 28.55 79 46.5 79Zm0 14C72.181 93 93 72.181 93 46.5S72.181 0 46.5 0 0 20.819 0 46.5 20.819 93 46.5 93Z",
    transform: "translate(67 175)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#242742",
    fillRule: "nonzero",
    d: "M96.61 216.72c0 2.27.589 4.067 1.766 5.39 1.177 1.313 2.78 1.969 4.812 1.969 1.886 0 3.36-.672 4.422-2.016 1.073-1.344 1.61-3.02 1.61-5.031h-1.172c0 1.146-.318 2.057-.954 2.734-.635.677-1.427 1.016-2.375 1.016-1.01 0-1.76-.339-2.25-1.016-.49-.687-.734-1.692-.734-3.015 0-1.51.245-2.594.734-3.25.5-.667 1.24-1 2.22-1 1.051 0 1.869.432 2.452 1.297.584.864.875 2.411.875 4.64l.14.625c0 3.302-.723 5.646-2.171 7.031-1.448 1.386-3.495 2.073-6.14 2.063h-.704v3.969h.813c4.25-.042 7.495-1.193 9.734-3.453 2.25-2.271 3.375-5.329 3.375-9.172v-.813c0-3.458-.776-5.958-2.328-7.5-1.552-1.552-3.557-2.328-6.016-2.328-2.468 0-4.437.714-5.906 2.14-1.469 1.428-2.203 3.334-2.203 5.72ZM123.923 232h4.828v-22.75h-4.516l-10.11 14.563v3.438h17.141v-3.891h-4.937l-.813.078h-6.5l4.828-7.562h.157v9.593l-.079.547v5.985Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationSignUpDesktop);
export default __webpack_public_path__ + "static/media/illustration-sign-up-desktop.ce2024babf0bc98a8862252535b544c9.svg";
export { ForwardRef as ReactComponent };